import { ReactComponent as Search } from './search.svg'

export default Search
